module.exports = __webpack_public_path__ + "static/media/html.35d2dff9.png";